<template>
  <div class="index">
    <router-view />
    <van-tabbar v-model="active" route safe-area-inset-bottom active-color="#1989fa" inactive-color="#969799">
      <van-tabbar-item to="/home" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item to="/bill" icon="balance-list-o">还款</van-tabbar-item>
      <van-tabbar-item to="/service" icon="service-o" :badge="csBadge">客服</van-tabbar-item>
      <van-tabbar-item to="/my" icon="user-o">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { csUnread } from '@/api/request'

export default {
  name: 'Index',
  data() {
    return {
      active: 0,
      csUnreadCount: 0,
      unreadTimer: null
    }
  },
  computed: {
    onService() {
      return this.$route.path === '/service'
    },
    csBadge() {
      if (this.onService || this.csUnreadCount <= 0) return ''
      return this.csUnreadCount > 99 ? '99+' : String(this.csUnreadCount)
    }
  },
  watch: {
    '$route.path'() {
      this.refreshUnread()
    }
  },
  methods: {
    async refreshUnread() {
      if (!localStorage.getItem('token')) {
        this.csUnreadCount = 0
        return
      }
      // 正在看客服页时由消息轮询清零，红标不显示
      if (this.onService) {
        this.csUnreadCount = 0
        return
      }
      try {
        const res = await csUnread()
        this.csUnreadCount = Number((res.data && res.data.unread) || 0)
      } catch (e) {
        /* silent */
      }
    },
    startUnreadPoll() {
      this.stopUnreadPoll()
      this.refreshUnread()
      this.unreadTimer = setInterval(() => {
        this.refreshUnread()
      }, 4000)
    },
    stopUnreadPoll() {
      if (this.unreadTimer) {
        clearInterval(this.unreadTimer)
        this.unreadTimer = null
      }
    }
  },
  mounted() {
    this.startUnreadPoll()
  },
  activated() {
    this.startUnreadPoll()
  },
  deactivated() {
    this.stopUnreadPoll()
  },
  beforeDestroy() {
    this.stopUnreadPoll()
  }
}
</script>

<style lang="less" scoped>
.index {
  height: 100%;
  background: linear-gradient(90deg, #e0f0ff, #edf6ff);
}
</style>
